module.exports = __webpack_public_path__ + "img/logo.e9d12d38.png";